import Button from '@restart/ui/esm/Button'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import MainLoading from '../../../../utils/MainLoading'
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie'
import { useTranslation } from 'react-i18next'

const AdminUserInfo = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    let userdata = JSON.parse(localStorage.getItem("user"))
    let dispatch = useDispatch()
    const {t} = useTranslation();

    const [data, setData] = useState({
        title: "",
        manager_name: "",
        manager_mobile: "",
        username: "",
    })

    const changeHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " 
        },
    }))

    useEffect(()=> {
        axios.get(`admin/profile/${userdata.id}`)
        .then(res => {
            setData({
                title: res.data.title ,
                manager_name: res.data.manager_name ,
                manager_mobile: res.data.manager_mobile ,
                username: res.data.username
            })
        })
        .catch(err => {
            console.log(err)
        })
    }, [])

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        const editedData = {
            title: data.title,
            manager_name: data.manager_name,
        }
        dispatch(fetchCsrfCookie())
        if (validator.current.allValid()) {
            setBtnLoading(false)
            axios.put(`admin/profile/${userdata.id}`, editedData)
            .then(res => {
                toast.dismiss()
                toast.success(t("toast_successfully_edited") , {position: 'bottom-right',className: 'foo-bar'})
                window.scrollTo(0, 0)
            })
            .catch(err => {
                toast.dismiss()
                toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
            })
        } else {
            setBtnLoading(false)
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
            setForceUpdate(1)
            validator.current.showMessages()
        }
    }

    return (
            <>
                {data.title === '' ?
                    <MainLoading />
                :
                    <div className="form-container userInfo">
                        <Form onSubmit={e => handleFromSubmit(e)}>
                            <Form.Group className="mb-3 col-md-5" controlId="title">
                                <Form.Label>{t("company name")} : </Form.Label>
                                <Form.Control  type="text"  name="title" value={data.title} onChange={changeHandler} />
                                <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                            </Form.Group>

                            <Form.Group className="mb-3 col-md-5" controlId="manager_name">
                                <Form.Label> {t("CEO name")} : </Form.Label>
                                <Form.Control type="text" name="manager_name" value={data.manager_name} onChange={changeHandler} />
                                <span className='validator_error'>{validator.current.message('manager_name', data.manager_name, 'required')}</span>
                            </Form.Group>

                            <Form.Group className="mb-3 col-md-5" controlId="manager_mobile">
                                <Form.Label> {t("CEO phone number")} : </Form.Label>
                                <p className='showUserInfo'>{data.manager_mobile} </p>
                            </Form.Group>

                            <Form.Group className="mb-3 col-md-5" controlId="username">
                                <Form.Label> {t("username")} : </Form.Label>
                                <p className='showUserInfo'>{data.username} </p>
                            </Form.Group>

                            <Button variant="primary" type="submit" className="btn green-btn mt-3" disabled={btnLoading ? true : false}>
                                {t("edit")}
                            </Button>
                        </Form>
                    </div>
                }
            </>
    )
}

export default AdminUserInfo

